module.exports = __webpack_public_path__ + "media/images/plans/plan-photo-2-ed7c9a5ddcd9c5d9a46398d3a54304f4.png";